//splide
const homeSlide = document.getElementById('homeSlide');
let splide = new Splide(homeSlide, {
  type: 'loop',
  perPage: 3,
  autoplay: true,
  interval: 3500,
  speed: 500,
  easing: 'cubic-bezier(0,1,.75,1.1)',
  gap: '24px',
  focus: 'center',
  pagination: false,
  breakpoints: {
    840: {
      perPage: 2,
      focus: 0,
    },
    640: {
      perPage: 1,
      arrows: false,
      pagination: true,
    },
  },
});

splide.mount();
